import type { ReactNode } from 'react'

import S from './TasksEmptyState.module.scss'

export type TasksEmptyStateProps = {
  title: string
  description: string
  icon: ReactNode
  ariaLabel?: string
}

export default function TasksEmptyState({
  title,
  description,
  icon,
  ariaLabel
}: TasksEmptyStateProps) {
  return (
    <div className={S.root} role="status" aria-label={ariaLabel ?? title}>
      <div className={S.icon} aria-hidden>
        {icon}
      </div>
      <div className={S.text}>
        <h2 className={S.title}>{title}</h2>
        <p className={S.description}>{description}</p>
      </div>
    </div>
  )
}
